export default __webpack_public_path__ + "static/media/purchasing.8f6622a3.png";